import {Route, Redirect, Switch} from 'react-router-dom';
import App from '../frontend/app/containers/App';
import React from 'react';

export default (
    <Switch>
        <Redirect exact from='/' to='/order/region'/>
        <Route path='/' component={App} />
    </Switch>
);
